import { defaultApi, publicApi } from '@/api';
import { components } from '@/types/api';

export async function authenticatePublicView({
  roadmapPublicLinkUrl,
  password,
}: {
  roadmapPublicLinkUrl: string;
  password?: string;
}) {
  const { data } = await defaultApi.post<components['schemas']['PublicViewRoadmap']>(
    `/public-views/${roadmapPublicLinkUrl}`,
    { password }
  );

  return data;
}

export async function getPublicViewSso(roadmapPublicLinkUrl: string) {
  const { data } = await publicApi.get<boolean>(`/public-views/${roadmapPublicLinkUrl}/sso`);
  return data;
}
